import clsx from 'clsx'
import React from 'react'

export type InputProps = {
  label: string
  type: string
  name: string
  value: string
  onChange: React.ChangeEventHandler<HTMLInputElement>
  error?: string
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>

const Input = ({
  label,
  type,
  name,
  value,
  onChange,
  error,
  ...rest
}: InputProps) => {
  return (
    <div className="flex flex-col gap-y-2">
      <label htmlFor={name} className="text-sm text-zinc-400">
        {label}
        {rest.required && '*'}
      </label>
      <input
        className={clsx(
          'input h-[59px] w-full rounded-lg border border-zinc-200 px-5 text-base text-slate-500 placeholder:text-base placeholder:text-[#CFD4DD]',
          error && 'error'
        )}
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        {...rest}
      />
      {error && <span className="text-red-500 text-sm">{error}</span>}
    </div>
  )
}

export default Input
